import React from 'react';
import {Avatar, Button, ButtonGroup, ListItem, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import _ from "lodash";
import { LoadingButton } from '@mui/lab';

// Un icono por integracion: `/images/icons/{slug}.svg`, siempre a color. El estado
// apagado (no instalada, o instalada pero sin activar) no lleva otro archivo: se
// resuelve con un filtro CSS, asi que sumar una integracion es dejar caer un solo
// SVG con el nombre del slug y nada mas.
//
// Las excepciones son integraciones cuyo icono ya existia con otro nombre: las dos
// primeras las usa tambien dropoffCarriers.js y las otras vienen del esquema viejo
// de pares. Se apunta al archivo en vez de copiarlo, y de paso queda anotado que el
// slug del plugin es "bluexpress" con una sola e y el archivo "blueexpress" con dos.
const ICON_FILE_BY_SLUG = Object.freeze({
    "bluexpress-tracking": "blueexpress.svg",
    "starken-tracking": "starken2.svg",
    "mercado-libre": "mercado-libre-color.svg",
    "default-bulk-order-importer": "default-bulk-order-importer-color.svg",
    "route-optimizer-by-delivery-zones": "route-optimizer-by-delivery-zones-color.svg",
    // Paket no publica un SVG: es el favicon de paketex.com (256 px).
    "paket-tracking": "paket-tracking.png",
});

// El `-color.svg` queda igual como segundo intento, para que una integracion que
// aparezca con el esquema viejo y no este en el mapa siga mostrando su icono.
const getPluginIconCandidates = (slug) => {
    if (!slug) return [];

    const basePath = "/images/icons";
    return [
        `${basePath}/${ICON_FILE_BY_SLUG[slug] || `${slug}.svg`}`,
        `${basePath}/${slug}-color.svg`,
    ];
}

const PluginListItem = (props) => {
    const candidates = getPluginIconCandidates(props.plugin.slug);
    const [iconAttempt, setIconAttempt] = React.useState(0);

    // Si la fila pasa a mostrar otra integracion, se vuelve a probar desde el primer
    // candidato; si no, arrastraria el descarte de la anterior.
    React.useEffect(() => setIconAttempt(0), [props.plugin.slug]);

    // Agotados los candidatos queda sin src y el Avatar cae en la inicial del nombre.
    const iconSrc = candidates[iconAttempt];

    return (
        <ListItem sx={{p: theme => theme.spacing(1, 0)}}>
            <ListItemAvatar>
                <Avatar
                    src={iconSrc}
                    alt={props.plugin.name}
                    imgProps={{ onError: () => setIconAttempt((attempt) => attempt + 1) }}
                    sx={{
                    boxShadow: 2,
                    bgcolor: "white",
                    width: 48,
                    height: 48,
                    p: 1,
                    filter: props.enabled ? "none" : "grayscale(1) brightness(0.9)",
                    opacity: props.enabled ? 1 : 0.7,
                    transition: "filter 200ms ease, opacity 200ms ease"
                    }}
                >
                    {props.plugin.name[0]}
                </Avatar>
            </ListItemAvatar>
            
            <ListItemText
                primary={
                    <Typography 
                        variant="h6"
                        sx={{
                            pr: 2,
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            maxWidth: "70%"
                        }}
                        >
                        {props.plugin.name}
                    </Typography>
                }
            />
            <ButtonGroup>
                {props.enableConfigButton === true &&
                    <Button
                        variant='contained'
                        size='small'
                        color='primary'
                        onClick={() => props.onConfig(props.plugin)}>
                        Configurar
                    </Button>
                }
                <LoadingButton
                    loading={props.inLoading}
                    variant="contained"
                    color={props.enabled ? "success" : "warning" }
                    size='small'
                    sx={{minWidth: 140}}
                    loadingPosition="end"
                    disabled={props.inLoading}
                    onClick={() => props.onToggle(props.plugin)}>
                        {props.enabled ? props.onText : props.offText}
                </LoadingButton>
            </ButtonGroup>
        </ListItem>
    );
};

export default PluginListItem;